import { render, staticRenderFns } from "./newAdd.vue?vue&type=template&id=23abedf0&scoped=true&"
import script from "./newAdd.vue?vue&type=script&lang=js&"
export * from "./newAdd.vue?vue&type=script&lang=js&"
import style0 from "./newAdd.vue?vue&type=style&index=0&id=23abedf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23abedf0",
  null
  
)

export default component.exports